<h2 mat-dialog-title>{{data.messageText}}</h2>
<mat-dialog-content class="mat-typography" [innerHTML]="data.messagePayload.error">
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="btn btn-link btn-sm" (click)="copyToClipboard(data.messagePayload.error)">[Copy Message to Clipboard]</button>
  <button class="btn btn-secondary btn-sm" mat-dialog-close>Close</button>
</mat-dialog-actions>
